import Icon from '../components/Icon.vue'

Icon.register({
  random: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M505 359C514.3 368.4 514.3 383.6 505 393L425 473C410 488 384 477.4 384 456V416H325.2A12-12 0 0 0 316.4 412.2L245.9 336.6 299.2 279.4 352 336H384V296C384 274.6 409.9 264 425 279L505 359zM12 176H96L148.8 232.6 202.1 175.4 131.6 99.8A12-12 0 0 1 122.8 96H12C5.4 96 0 101.4 0 108V164C0 170.6 5.4 176 12 176zM384 176V216C384 237.4 410 248 425 233L505 153C514.3 143.6 514.3 128.4 505 119L425 39C409.9 24 384 34.6 384 56V96H325.2A12-12 0 0 1 316.4 99.8L96 336H12C5.4 336 0 341.4 0 348V404C0 410.6 5.4 416 12 416H122.8C126.1 416 129.3 414.6 131.6 412.2L352 176H384z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/random.js
// module id = lVwD
// module chunks = 144